import { render } from "./SurveyQuestionAnswers.vue?vue&type=template&id=7fe9d646&scoped=true"
import script from "./SurveyQuestionAnswers.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionAnswers.vue?vue&type=script&lang=js"

import "./SurveyQuestionAnswers.vue?vue&type=style&index=0&id=7fe9d646&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe9d646"]])

export default __exports__